const toFiniteNumber = (value) => {
  const parsedValue = Number.parseFloat(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

const roundCurrency = (value) =>
  Math.round((toFiniteNumber(value) + Number.EPSILON) * 100) / 100;

export const normalizeReceiptPayments = (payments = []) =>
  payments.map((payment) => ({
    ...payment,
    amount: roundCurrency(payment?.amount),
  }));

export const calculateReceiptTotals = (payments = [], prevBalance = 0) => {
  const normalizedPayments = normalizeReceiptPayments(payments);
  const amountPaid = roundCurrency(
    normalizedPayments.reduce((total, payment) => total + Number(payment?.amount || 0), 0)
  );

  return {
    amountPaid,
    balanceDue: roundCurrency(Number(prevBalance || 0) - amountPaid),
  };
};

export const getReceiptFormInitialValues = ({
  invoice,
  receiptToEdit,
  cashierName,
  formatDateTimeForInput,
  selectedUserId,
  selectedInvoiceId,
  selectedReservationId,
}) => {
  const payments = normalizeReceiptPayments(
    receiptToEdit?.payments ?? [{ method: "", amount: 0 }]
  );
  const prevBalance = roundCurrency(
    receiptToEdit?.prevBalance ?? invoice?.amountDue ?? 0
  );
  const { amountPaid, balanceDue } = calculateReceiptTotals(payments, prevBalance);

  return {
    id: receiptToEdit?.id ?? null,
    receiptNumber: receiptToEdit?.receiptNumber ?? null,
    receiptDate: receiptToEdit?.receiptDate
      ? formatDateTimeForInput(receiptToEdit.receiptDate)
      : formatDateTimeForInput(new Date()),
    amountPaid,
    reservationId:
      receiptToEdit?.reservationId ??
      invoice?.reservation?.id ??
      invoice?.reservationId ??
      selectedReservationId ??
      0,
    userId:
      receiptToEdit?.userId ?? invoice?.user?.userId ?? invoice?.userId ?? selectedUserId ?? "",
    invoiceId: receiptToEdit?.invoiceId ?? invoice?.id ?? selectedInvoiceId ?? 0,
    payments,
    paidBy: receiptToEdit?.paidBy ?? "",
    paymentDate: receiptToEdit?.paymentDate
      ? formatDateTimeForInput(receiptToEdit.paymentDate)
      : "",
    prevBalance,
    balanceDue,
    cashierName: receiptToEdit?.cashierName ?? cashierName,
  };
};


